import React from "react";
import DocList from "../../_components/Purchasing/PurchaseDocList";
import { FiFileText, FiClock, FiCheckCircle, FiXCircle, FiUser, FiDollarSign, FiCreditCard, FiHome } from "react-icons/fi";
import { T, DocStatusBadge, fmtMYR } from "../../_components/Purchasing/PurchaseShared";
import { getPaymentVouchers, getPaymentVoucherKpis, deletePaymentVoucher } from "../../_services/finance.service";

export default function PaymentVouchers() {
    return (
        <DocList
            docType="Payment Voucher"
            basePath="/finance/payment-vouchers"
            fetchList={getPaymentVouchers}
            fetchKpis={getPaymentVoucherKpis}
            deleteItem={deletePaymentVoucher}
            statuses={["All", "Draft", "Pending for Approval", "Approved", "Rejected"]}
            kpiCards={[
                { label: "Total PVs", key: "total", icon: FiFileText, color: T.accent },
                { label: "Pending", key: "pending", icon: FiClock, color: T.warning },
                { label: "Approved", key: "approved", icon: FiCheckCircle, color: T.success },
                { label: "Rejected", key: "rejected", icon: FiXCircle, color: T.danger },
            ]}
            previewFields={[
                { icon: FiClock, label: "Date", key: "date" },
                { icon: FiHome, label: "Pay To (Company)", key: "supplier" },
                { icon: FiUser, label: "Contact Person", key: "contactPerson" },
                { icon: FiCreditCard, label: "Payment Method", key: "paymentMethod" },
                { icon: FiDollarSign, label: "Total Payment", key: "payAmount", render: (v) => fmtMYR(v) },
            ]}
            searchOptions={[
                { key: "all", label: "All" },
                { key: "id", label: "PV No." },
                { key: "date", label: "Date" },
                { key: "contactPerson", label: "Contact Person" },
                { key: "supplier", label: "Company Name" },
            ]}
            customColumns={[
                { key: "id", label: "Payment Voucher No." },
                { key: "date", label: "Date" },
                { key: "contactPerson", label: "Contact Person", render: (v) => <span style={{ fontWeight: 600 }}>{v || "—"}</span> },
                { key: "supplier", label: "Company Name" },
                { key: "payAmount", label: "Total Payment", render: (v) => <span style={{ fontWeight: 700 }}>{fmtMYR(v)}</span> },
                { key: "status", label: "Status", render: (v) => <DocStatusBadge value={v} /> },
            ]}
        />
    );
}